<script>
import getLabel from "foundation/js/getLabel";
import options from "./ReceiptContent.options";
export default options;
</script>

<template>
  <article class="kb-receipt-content">
    <div class="kb-receipt-content__main-content-wrapper">
      <table class="kb-receipt-content__table">
        <thead class="kb-receipt-content__table-head">
          <tr role="presentation">
            <th class="kb-receipt-content__table-head-title" colspan="2">
              {{ getLabel("orderDateTitle") }}
              <span
                class="kb-receipt-content__table-head-title--result kb-receipt-content__table-head-title--margin-bottom-05-rem"
                >{{ receiptResults.orderNumber }}</span
              >
            </th>
          </tr>
          <tr role="presentation">
            <th class="kb-receipt-content__table-head-title" colspan="2">
              {{ getLabel("orderNumberTitle") }}
              <span class="kb-receipt-content__table-head-title--result">{{
                receiptResults.orderDate
              }}</span>
            </th>
          </tr>
        </thead>
        <thead class="kb-receipt-content__table-head--three-col">
          <tr>
            <th class="kb-receipt-content__table-head-title" colspan="1">
              {{ getLabel("orderProductTitle") }}
            </th>
            <th class="kb-receipt-content__table-head-title kb-receipt-content__table-head-title--text-align-center" colspan="1">
              {{ getLabel("orderAmountTitle") }}
            </th>
            <th
              class="kb-receipt-content__table-head-title kb-receipt-content__table-head-title--text-align-right"
              colspan="1"
            >
              {{ getLabel("orderPriceTitle") }}
            </th>
          </tr>
        </thead>

        <tbody class="kb-receipt-content__table-body">
          <tr>
            <td class="kb-receipt-content__table-body-data" colspan="4">
              <div class="kb-receipt-content__table-horizontal-line"></div>
            </td>
          </tr>

          <template
            v-for="(product, index) in receiptResults.products"
            :key="index"
          >
            <tr>
              <td
                class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--product-name"
                colspan="1"
              >
                {{ product.productTitle }}
                <template v-if="product.productTitleAdditional">
                  <span>{{ product.productTitleAdditional }}</span>
                  <span v-if="product.isUdlaansvare && getLabel('udlaansvareText')">{{ getLabel('udlaansvareText') }}</span>
                </template>
              </td>
              <td
                class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--text-align-center"
                colspan="1"
              >
                {{ product.productQuantity }}
              </td>
              <td
                class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--text-align-right"
                colspan="1"
              >
                {{ product.productPrice }}
              </td>
            </tr>
          </template>

          <tr>
            <td class="kb-receipt-content__table-body-data" colspan="4">
              <div class="kb-receipt-content__table-horizontal-line"></div>
            </td>
          </tr>

          <tr>
            <td
              class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--product-name"
              colspan="1"
            >
              {{ getLabel("deliveryTitle") }}
              <span>{{ receiptResults.deliveryAddress }}</span>
              {{ receiptResults.deliveryType }}
            </td>
            <td class="kb-receipt-content__table-body-data" colspan="1"></td>
            <td
              class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--text-align-right"
              colspan="1"
            >
              {{ receiptResults.deliveryPrice }}
            </td>
          </tr>

          <tr>
            <td class="kb-receipt-content__table-body-data" colspan="4">
              <div
                class="kb-receipt-content__table-horizontal-line kb-receipt-content__table-horizontal-line--bottom"
              ></div>
            </td>
          </tr>

          <tr class="kb-receipt-content__table-body--row-total">
            <td class="kb-receipt-content__table-body-data" colspan="2">
              {{ getLabel("totalTitle") }}
            </td>
            <td
              class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--text-align-right"
              colspan="2"
            >
              {{ receiptResults.total }}
            </td>
          </tr>

          <tr class="kb-receipt-content__table-body-data">
            <td
              class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--pale"
              colspan="2"
            >
              {{ getLabel("VATTitle") }}
            </td>
            <td
              class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--pale kb-receipt-content__table-body-data--text-align-right"
              colspan="2"
            >
              {{ receiptResults.VAT }}
            </td>
          </tr>

          <tr>
            <td
              class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--pale"
              colspan="2"
            >
              {{ getLabel("discountTitle") }}
            </td>
            <td
              class="kb-receipt-content__table-body-data kb-receipt-content__table-body-data--pale kb-receipt-content__table-body-data--text-align-right"
              colspan="2"
            >
              {{ receiptResults.discount }}
            </td>
          </tr>

          <tr>
            <td class="kb-basket-aside__button-wrapper" colspan="4">
              <button
                @click="print"
                id="print_external"
                class="kb-button kb-button--full-color-spot"
              >
                {{ getLabel("printButtonText") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="kb-receipt-content__seller-address">
      <p class="kb-receipt-content__seller-address-title">
        {{ getLabel("sellerAddressTitle") }}
      </p>
      <p>
        {{ getLabel("sellerAddressName") }}
      </p>
      <p>
        {{ getLabel("sellerAddressStreet") }}
      </p>
      <p>
        {{ getLabel("sellerAddressCity") }}
      </p>
    </div>
  </article>
</template>
